module.exports = __webpack_public_path__ + "fa-solid-900.faff92145777a3cbaf8e.woff";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-solid-900.woff
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-solid-900.woff
// module chunks = styles